module.exports = __webpack_public_path__ + "img/date_white_24dp@2x.22b88b83.png";